import { render } from "./AddressPage.vue?vue&type=template&id=876a90bc"
import script from "./AddressPage.vue?vue&type=script&lang=js"
export * from "./AddressPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__